import instance from './axios'

export const getOrders = async (key, userId) => {
  const { data } = await instance.get(`/orders?user=${userId}`)

  return data
}
